import LineDiyHttpRequest from './LineDiyServiceRequest'

export default class FileProvider extends LineDiyHttpRequest {
  uploadPrivateDocument (formData) {
    return this.axiosInstance.post('/file/upload/private?accessMode=ACCESS_URL', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
